import React from "react";
import { useHistory } from "react-router-dom";

const OrderManagement = () => {
  const history = useHistory();
  React.useEffect(() => history.push("/order-mngmt/orders"), [history]);
  return <div />;
};

export default OrderManagement;
